import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SROrderConfirmComponent } from '../SR-order-confirm/SR-order-confirm.component';
import { InfiniteScrollModule } from "ngx-infinite-scroll";//上拉下拉
import { FooterRefreshModule } from "../component/footer-refresh/footer-refresh.module";//加载和刷新
import { LazyLoadImageModule } from 'ng-lazyload-image';//图片懒加载
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot([{ path: 'srOrderConfirm', component: SROrderConfirmComponent }]),
        InfiniteScrollModule,
        FooterRefreshModule,
        LazyLoadImageModule,
        FormsModule
    ],
    exports: [],
    declarations: [
        SROrderConfirmComponent
    ],
    providers: [],
})
export class SROrderConfirmModule { }